module.exports = __webpack_public_path__ + "img/icon-livecasino-yellow.df7f5eaf.svg";